import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
const Index = (props) => {
  const handleChange = (info) => {
    if (info.file.status !== "uploading") {
    }
    if (info.file.status === "done") {
      props?.form?.setFieldValue(props?.name, info.file.originFileObj);
      message.success(`${info.file.name}`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  };

  const customUpload = (options) => {
    return options?.onSuccess("ok", { success: true });
  };

  return (
    <Upload
      maxCount={1}
      name="file"
      customRequest={customUpload}
      onChange={handleChange}
    >
      <Button icon={<UploadOutlined />}>Файл оруулах</Button>
    </Upload>
  );
};

export default Index;
